import { render, staticRenderFns } from "./hotelReportGoods.vue?vue&type=template&id=645a184a&"
import script from "./hotelReportGoods.vue?vue&type=script&lang=js&"
export * from "./hotelReportGoods.vue?vue&type=script&lang=js&"
import style0 from "./hotelReportGoods.vue?vue&type=style&index=0&id=645a184a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports